import "./offices.css";

// Fetch all office highlight slides
const previewImageElement = document.querySelector<HTMLImageElement>(
  ".s-about-offices__preview-image",
);
const officeElements = document.querySelectorAll<HTMLElement>(
  ".s-about-offices__office",
);

// Add event handlers
officeElements.forEach((element) =>
  element.addEventListener("click", () => selectOffice(element)),
);

function selectOffice(element: HTMLElement) {
  officeElements.forEach((element) =>
    element.classList.remove("s-about-offices__office--selected"),
  );

  element.classList.add("s-about-offices__office--selected");

  const { src, alt } = element.dataset;

  if (previewImageElement) {
    previewImageElement.src = src || "";
    previewImageElement.alt = alt || "";
  }
}
